export const CAREER_EMPLOYMENT_TYPE_EXECUTIVE = 7;
export const CAREER_EMPLOYMENT_TYPE_FREELANCE = 8;
export const CAREER_EMPLOYMENT_TYPE_PUBLICOFFICER = 9;

export const EMPLOYMENT_TYPE_MAP: Record<string, number> = {
  executive: CAREER_EMPLOYMENT_TYPE_EXECUTIVE,
  freelance: CAREER_EMPLOYMENT_TYPE_FREELANCE,
  publicOfficer: CAREER_EMPLOYMENT_TYPE_PUBLICOFFICER,
};
